import React from 'react';
import classNames from 'classnames';
import { Tooltip as MuiTooltip } from '@mui/material';
import styles from './Tooltip.module.scss';
import Icon, { IconName } from '../Icon/Icon';

export interface TooltipProps {
  icon?: IconName;
  title: string;
}

const Tooltip: React.FC<TooltipProps> = ({ title, icon = 'infoCircle' }) => {
  return (
    <MuiTooltip
      key={title}
      title={title}
      slotProps={{
        popper: {
          modifiers: [
            {
              name: 'offset',
              options: {
                offset: [0, -10],
              },
            },
          ],
        },
      }}>
      <div className={classNames(styles.root)}>
        <Icon name={icon} width={16} height={16} />
      </div>
    </MuiTooltip>
  );
};

export default Tooltip;
